import Avatar from '@atlaskit/avatar';
import { colors, fontFamily } from '@atlaskit/theme';
import React from 'react';
import styled from 'styled-components';
import { getInitials } from '../utils/initials';

export type UserAvatarProps = {
  readonly userName: string;
  readonly avatarSrc?: string;
  readonly enableTooltip?: boolean;
  readonly isDisabled?: boolean;
  readonly isFocus?: boolean;
};

export function UserAvatar({
  userName,
  avatarSrc,
  enableTooltip = false,
  isDisabled = false,
  isFocus = false
}: UserAvatarProps) {
  if (avatarSrc !== undefined) {
    return (
      <Avatar
        src={avatarSrc}
        name={userName}
        size="small"
        enableTooltip={enableTooltip}
        isDisabled={isDisabled}
        isFocus={isFocus}
      />
    );
  } else {
    return (
      <Avatar
        component={({ className, ...props }) => (
          <div className={className}>
            <Initials {...props}>{getInitials(userName)}</Initials>
          </div>
        )}
        name={userName}
        size="small"
        isDisabled={isDisabled}
        isFocus={isFocus}
        enableTooltip={enableTooltip}
      />
    );
  }
}

const Initials = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: ${fontFamily};
  font-size: 10px;
  line-height: 10px;
  color: ${colors.N500};

  width: 100%;
  height: 100%;
  background-color: ${colors.N40};
  border-radius: 50%;
`;
